import assetsPaths from '@/constants/assetsPaths';
import type { AppConfig } from '@/core/app/types/AppConfig';

export const appConfig: AppConfig = {
    appInfo: {
        name: 'FleetDoc',
        title: 'FleetDoc',
        description: 'FleetDoc',
        logoUrl: assetsPaths.logos.brand,
    },
    env: {
        currentEnv: process.env.NODE_ENV,
        isDev: process.env.NODE_ENV === 'development',
        isTest: process.env.NODE_ENV === 'test',
        isProduction: process.env.NODE_ENV === 'production',
        appKey: process.env.NEXT_PUBLIC_APP_KEY ?? '',
        apiBaseUrl: process.env.NEXT_PUBLIC_API_BASE_URL ?? '',
        otpCountdown: Number(process.env.NEXT_PUBLIC_OTP_COUNTDOWN ?? 300),
    },
    i18n: {
        locales: ['en', 'ar'],
        defaultLocale: 'en',
        localeTimeZone: 'Africa/Egypt',
    },
    appearance: {
        themes: ['system', 'light', 'dark'],
        defaultTheme: 'light',
        accentColor: '#017E8D',
    },
    filter: {
        defaultPageQueryName: 'page',
        defaultPage: 1,
        defaultPerPageQueryName: 'per_page',
        defaultPerPage: 10,
        maxPerPage: 1000000,
        defaultSortByQueryName: 'sort_by',
        defaultSortBy: 'id',
        defaultOrderByQueryName: 'order_by',
        defaultOrderBy: 'desc',
        defaultSearchQueryName: 'search',
        defaultSearch: '',
        baseFilters: ['page', 'per_page', 'sort_by', 'order_by', 'search'],
    },
    formatter: {
        dateTime: 'D MMM YYYY - hh:mm a',
        date: 'D MMM YYYY',
        time: 'hh:mm A',
    },
    formValidation: {
        mode: 'onTouched',
    },
    http: {
        get: {
            clearOnRefetch: true,
            clearOnUnmount: true,
            refetchOnWindowFocus: true,
            retryCount: 0,
        },
        post: {
            stopLoadingOnSuccess: false,
            stopLoadingOnError: true,
        },
        put: {
            stopLoadingOnSuccess: false,
            stopLoadingOnError: true,
        },
        patch: {
            stopLoadingOnSuccess: true,
            stopLoadingOnError: true,
        },
        delete: {
            stopLoadingOnSuccess: true,
            stopLoadingOnError: true,
        },
    },
};
